import PropTypes from 'prop-types';
import React from 'react';
import { unformat, toFixed } from 'accounting';
import { isNil } from 'lodash';

const DEFAULT_DECIMAL_PRECISION = 6;

// custom react-jsonschema-form field for percent input
function PercentField(props) {
  const value = isNil(props.formData)
    ? ''
    : unformat(toFixed(props.formData * 100, DEFAULT_DECIMAL_PRECISION));
  const onChange = (event) => {
    if (event.target.value === '') {
      props.onChange(undefined);
    } else {
      props.onChange(event.target.value / 100);
    }
  };

  return [
    <>
      <label key="label" className="control-label">
        {props.schema.title}
        {props.required ? '*' : ''}
      </label>
      {props.schema.description && (
        <>
          <br />
          <span>{props.schema.description}</span>
        </>
      )}
    </>,
    <div key="input" className="input-group">
      <input
        className="form-control"
        type="number"
        onChange={onChange}
        value={value}
        disabled={props.uiSchema['ui:enumDisabled']}
      />
      <div className="input-group-addon">%</div>
    </div>,
  ];
}

PercentField.propTypes = {
  formData: PropTypes.number,
  schema: PropTypes.object,
  onChange: PropTypes.func,
};

export default PercentField;
